import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const InnerContainer = styled("nav")`
    display: flex;
    height: 2.75rem;
    flex: 1 1 0;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    max-width: ${breakpoints.values.xl}px;
    border-bottom: 0.0625rem solid ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.borderColor};

    padding: 0.4rem 0;

    @media (min-width: ${breakpoints.values.md}px) {
        height: 3.75rem;
        padding: 0.5rem 2.5rem 0.5rem 2.5rem;
    }

    .header-adaptive-checkout {
        flex-shrink: 0;
    }
`
export const LeftSideContainer = styled("div")`
    flex: 1 1 0;
    display: flex;
    align-items: center;
`
export const RightSideContainer = styled("div")`
    flex: 1 1 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`

export const HeaderContainer = styled("header")`
    box-shadow: ${({theme}) => theme.uxfabric.elevation.header};
`
